const Errors = {
  noTransforms: 'No transformations to execute!',
  outOfBounds: 'Your triangle has gone out of bounds.',
  noMedal: 'Cannot get medal on game lost',
  hitObstacle: 'You hit an obstacle. Try again.',
}
export default Errors;